import React from 'react';
import { change, FieldArray } from 'redux-form';
import classNames from 'classnames';
import { useDispatch } from 'react-redux';
import styles from './assets/program-array-fields.module.scss';
import RenderDomainArray from './RenderDomainArray';
import RenderTargetArray from './RenderTargetArray';

const RenderFieldArray = (props: any) => {
    const {
        fields,
        setIsManualChangeValue,
        isManualChangeValue,
        setTargetManualChangeValue,
        targetManualChangeValue,
        programBookId,
    } = props;
    return (
        <ul className={classNames(styles.ul, styles.ulSection)}>
            {fields.map((member: any, index: number, array: any) => (
                <RenderSubFields
                    key={`i-${index}`}
                    member={member}
                    fields={array}
                    isLast={index + 1 === fields.length}
                    isNotFirst={!!index}
                    index={index}
                    setIsManualChangeValue={setIsManualChangeValue}
                    isManualChangeValue={isManualChangeValue}
                    setTargetManualChangeValue={setTargetManualChangeValue}
                    targetManualChangeValue={targetManualChangeValue}
                    programBookId={programBookId}
                />
            ))}
        </ul>
    );
};
type Props = {
    member: any;
    index: number;
    fields: any;
    isLast: boolean;
    isNotFirst: boolean;
    setIsManualChangeValue: (it: boolean) => void;
    isManualChangeValue: any;
    setTargetManualChangeValue: (it: string) => void;
    targetManualChangeValue: any;
    programBookId?: any;
};

const RenderSubFields: React.FunctionComponent<Props> = ({
    member,
    index,
    fields,
    isLast,
    isNotFirst,
    setIsManualChangeValue,
    isManualChangeValue,
    setTargetManualChangeValue,
    targetManualChangeValue,
    programBookId,
}) => {
    const dispatch = useDispatch();
    const row = fields.get(index);
    const deleteRow = () => {
        if (!row.id) {
            fields.remove(index);
        } else {
            dispatch(change('payment-form', `${member}.status`, 2));
        }
    };

    const backRow = () => {
        dispatch(change('payment-form', `${member}.status`, 1));
    };
    const creditStyle = {
        background: 'grey',
    };

    const isApplied: boolean = +row.status === 3;

    return (
        <li key={index}>
            <div className={classNames(styles.treeview__level, styles.sectionWrap)} data-level="SE">
                <span className={classNames(styles.leveltitle)}>Section - {row.title}</span>
                {row.title == 'Behavior Reduction' ? (
                    <FieldArray
                        setIsManualChangeValue={setIsManualChangeValue}
                        isManualChangeValue={isManualChangeValue}
                        setTargetManualChangeValue={setTargetManualChangeValue}
                        targetManualChangeValue={targetManualChangeValue}
                        name={`${member}.targets`}
                        component={RenderTargetArray}
                        programBookId={programBookId}
                    />
                ) : (
                    <div>
                        <FieldArray
                            setIsManualChangeValue={setIsManualChangeValue}
                            isManualChangeValue={isManualChangeValue}
                            setTargetManualChangeValue={setTargetManualChangeValue}
                            targetManualChangeValue={targetManualChangeValue}
                            name={`${member}.values`}
                            component={RenderDomainArray}
                            programBookId={programBookId}
                        />
                    </div>
                )}
            </div>
        </li>
    );
};
export default RenderFieldArray;
